import $ from "jquery";
window.$ = window.jQuery = $;

// ⚠️ All legacy scripts must be loaded *after* jQuery is global
(async () => {
  await import("bootstrap");
})();

